import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  MenuItem,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Label from "../../components/Label/Label";
import Buttons from "../../components/Controls/Buttons/Button";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

const DateInput = ({ label, value, onChange, minDate, maxDate }) => {
  return (
    <DatePicker
      selected={value ? new Date(value) : null}
      showYearDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={150}
      // popperClassName="custom-datepicker-popper"
      onChange={(date) => {
        onChange(date);
      }}
      dateFormat="dd-MMM-yyyy"
      minDate={minDate}
      maxDate={maxDate}
      customInput={
        <TextField
          label={label}
          size="small"
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      }
    />
  );
};

const BatchFilterPopup = ({
  open,
  onClose,
  filterValues,
  onChange,
  onReset,
  onGenerate,
  isStatusVisible,
  data,
  filterOptions,
  userList,
  filterConfig 
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      sx={{ borderRadius: "16px !important", margin: 0 }}
      BackdropProps={{
        style: { backgroundColor: "transparent" },
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxWidth: "276px",
          boxShadow: "none",
          bottom: 0,
          position: "fixed",
          left: 58,
          margin: 0,
          boxShadow: "none",
          maxHeight: "calc(100vh - 150px)",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{ backgroundColor: "#E8EDF4", minHeight: "calc(100vh - 143px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 14,
            fontWeight: 600,
            paddingLeft: "10px",
            alignItems: "center",
            overflow: "hidden",
            height: "48px",
          }}
        >
          Filter
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            height: "100%",
            padding: "5px",
            overflow: "auto",
            height: "calc(100vh - 200px)",
          }}
        >
          <DialogContent
            sx={{
              padding: "0px",
              boxShadow: "none",
              overflow: "auto",
            }}
          >
            {filterConfig.map((item) => {

              // 🔹 SELECT
              if (item.type === "select") {
                return (
                  <Box
                    key={item.key}
                    display="flex"
                    flexDirection="column"
                    gap={2}
                    p={1}
                    mb={1}
                    sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
                  >
                    <Label text={item.label} />

                    <TextField
                      select
                      label={item.label}
                      size="small"
                      fullWidth
                      value={filterValues?.[item.key]}
                      onChange={(e) => onChange(item.key, e.target.value)}
                    >
                      <MenuItem value="">Select</MenuItem>

                      {item.options?.map((option) => (
                        <MenuItem
                          key={option[item.optionKey]}
                          value={option[item.optionKey]}
                        >
                          {option[item.optionLabel]}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>
                );
              }

              // 🔹 DATE RANGE
              if (item.type === "dateRange") {
                return (
                  <Box
                    key={item.key}
                    display="flex"
                    flexDirection="column"
                    gap={2}
                    p={1}
                    mb={1}
                    sx={{
                      backgroundColor: "#ffff",
                      borderRadius: "8px",
                      boxShadow: "none",
                    }}
                  >
                    <Label text={item.label} />

                    <DateInput
                      label="From"
                      value={filterValues?.[item.fromKey]}
                      onChange={(val) => onChange(item.fromKey, val)}
                      maxDate={filterValues?.[item.toKey]}
                    />

                    <DateInput
                      label="To"
                      value={filterValues?.[item.toKey]}
                      onChange={(val) => onChange(item.toKey, val)}
                      minDate={filterValues?.[item.fromKey]}
                    />
                  </Box>
                );
              }

              return null;
            })}
          </DialogContent>
          <Box
            display="flex"
            justifyContent="end"
            gap={1}
            p={1}
            sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
          >
            <Button variant="outlined" onClick={onReset}>
              Reset
            </Button>
            <Buttons
              text="Submit"
              variant="contained"
              onClick={onGenerate}
              loading={data?.loader}
            ></Buttons>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BatchFilterPopup;
